<template>
    <user-manage-edit/>
</template>

<script>
    import UserManageEdit from "_private/components/super/systemSetting/userManage/Edit";

    export default {
        components: {
            UserManageEdit
        }
    };
</script>
